var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Reenter Room")]),_c('div',_vm._l((_vm.rooms),function(room,id){return _c('a',{key:id,staticClass:"block",attrs:{"href":'/room/' + room.id}},[_vm._v(" "+_vm._s(room.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }